import Application from "../../Application";
import FormTypesGroupCategoriesPresenter, {
  IFormTypesGroupCategoriesPresenter
} from "../../presenter/formconfiguration/FormTypesGroupCategoriesPresenter";
import GetFormTypesGroupCategoriesInteractor from "./GetFormTypesGroupCategoriesInteractor";
import GetFormTypesInteractor from "./GetFormTypesInteractor";
import { FormTypeConstants } from "../../common/Constants";

export default class ShowFormTypesGroupCategoriesInteractor {
  private application: Application;
  private output?: IFormTypesGroupCategoriesPresenter;

  constructor(application) {
    this.application = application;
  }

  async getFormTypesGroupCategories() {
    return this.application.container
      .resolve<GetFormTypesGroupCategoriesInteractor>(
        "getFormTypesGroupCategories"
      )
      .execute();
  }

  async getFormTypes() {
    return this.application.container
      .resolve<GetFormTypesInteractor>("getFormTypes")
      .execute(FormTypeConstants.STATUS.PUBLISHED);
  }

  execute() {
    this.output = FormTypesGroupCategoriesPresenter({
      application: this.application,
      initialState: {
        formTypesGroupCategories: [],
        formTypes: []
      }
    });

    this.getFormTypesGroupCategories().then((formTypesGroupCategories) =>
      this.output?.setFormTypesGroupCategories(formTypesGroupCategories)
    );

    this.getFormTypes().then((formTypes) =>
      this.output?.setFormTypes(formTypes)
    );

    return this.output;
  }
}
